import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useLocation, Link } from 'react-router-dom'
import { displayUserPhone, userPhoneWhatsAppHref } from '../../utils/staffPhone'
import {
    KycAadhaarCell,
    KycDocumentImage,
    KycMethodBadge,
    KycOtpDetails,
} from './KycTableCells'
import KycRejectReasonFields from './KycRejectReasonFields'
const $ = require("jquery")

/** Amount this referred user generated for the referrer (field names vary by backend) */
/** API may return an array, or on error a string body — never pass non-arrays to .map. */
function normalizeKycList(payload) {
    let rows = []
    if (Array.isArray(payload)) rows = payload
    else if (payload && Array.isArray(payload.admin)) rows = payload.admin
    else if (payload && Array.isArray(payload.data)) rows = payload.data
    return rows.filter((x) => x != null && typeof x === 'object')
}

function earningFromReferredForReferrer(r) {
    if (!r || typeof r !== 'object') return null
    const keys = [
        'referral_earning_to_parent',
        'earning_for_referrer',
        'referrer_earning',
        'referral_commission',
        'refer_total_given',
        'total_referral_sent',
        'commission_to_upline',
        'refer_money',
        'referral_given',
        'totalReferralGiven'
    ]
    for (const k of keys) {
        if (r[k] == null || r[k] === '') continue
        const n = Number(r[k])
        if (Number.isFinite(n)) return n
    }
    return null
}

export default function View() {
    const location = useLocation();
    const path = location.pathname.split("/")[3];
    const [user, setUser] = useState();
    const [item, setVerify] = useState();
    const [challenge, setchallenge] = useState()
    const [txn, setTxn] = useState()
    const [txnwith, setTxnwith] = useState()
    const [walletLedger, setWalletLedger] = useState()
    const [referral, setReferral] = useState();
    const [kyc, setKyc] = useState();
    const [loading, setLoading] = useState(false);
    const [adminKyc, setAdminKyc] = useState({ name: '', email: '', dob: '', number: '' });
    const [adminKycFiles, setAdminKycFiles] = useState({ front: null, back: null });
    const [adminKycMsg, setAdminKycMsg] = useState('');
    const [adminKycSubmitting, setAdminKycSubmitting] = useState(false);
    const [showAdminKycPanel, setShowAdminKycPanel] = useState(false);
    const [showReferredUsersPanel, setShowReferredUsersPanel] = useState(false);
    const [activeTab, setActiveTab] = useState('games');
    const [kycRejectModal, setKycRejectModal] = useState({
        open: false,
        id: null,
        failReasonCode: "",
        failReasonNote: "",
        submitting: false,
    });
    
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    
    let baseUrl = '';
    if (nodeMode === "development") {
        baseUrl = beckendLocalApiUrl;
    } else {
        baseUrl = beckendLiveApiUrl;
    }

    let [mismatchValue, setmismatchValue] = useState(0);
    let [HoldBalance, setHoldBalance] = useState(0);
    const [winConvAmount, setWinConvAmount] = useState('');
    const [winConvCommissionPct, setWinConvCommissionPct] = useState('0');
    const [winConvLoading, setWinConvLoading] = useState(false);
    const [userIsOnline, setUserIsOnline] = useState(false);
    const [userOnHomePage, setUserOnHomePage] = useState(false);

    const refreshOnlineStatus = async () => {
        if (!path) return;
        try {
            const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
            const res = await axios.get(`${baseUrl}User/online-ids`, { headers });
            const ids = Array.isArray(res.data?.userIds) ? res.data.userIds : [];
            const homeIds = Array.isArray(res.data?.homeUserIds) ? res.data.homeUserIds : [];
            const uid = String(path);
            setUserIsOnline(ids.map(String).includes(uid));
            setUserOnHomePage(homeIds.map(String).includes(uid));
        } catch {
            /* keep last */
        }
    };
    const getUser = () => {
        let access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`get_user/${path}`, { headers })
            .then((res) => {
                console.log(res.data);
                setUser(res.data)
                Allrefer(res.data.referral_code)
                const expected = calculateExpectedBalance(res.data);
                const wb = Math.round((Number(res.data.Wallet_balance) || 0) * 100) / 100;
                const mismatch = Math.round((wb - expected) * 100) / 100;
                setmismatchValue(mismatch);
                setHoldBalance(res.data.hold_balance);
            }).catch((e) => {
                console.log(e)
            })
    }
    
    const [referCount, setRefercount] = useState([])
    const Allrefer = async (id) => {
        if (!id || id === '-' || id === '') {
            setRefercount([])
            return
        }
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        try {
            const res = await axios.get(baseUrl + `referral/code/${id}`, { headers })
            const d = res.data
            const list = Array.isArray(d) ? d : (d?.users || d?.data || d?.referrals || d?.admin || [])
            setRefercount(Array.isArray(list) ? list : [])
        } catch (e) {
            console.log(e)
            setRefercount([])
        }
    }

    const Allchallenge = async () => {
        const access_token = localStorage.getItem('token')
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`get_challange/user/${path}`, { headers })
            .then((res) => {
                setTxn(undefined)
                setTxnwith(undefined)
                setWalletLedger(undefined)
                setReferral(undefined)
                setKyc(undefined)
                const rows = Array.isArray(res.data) ? res.data : []
                setchallenge(rows)
            }).catch((e) => {
                console.log(e)
                setchallenge([])
            })
    }

    const transactionHis = () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`txn_history/user/${path}`, { headers })
            .then((res) => {
                setchallenge(undefined);
                setReferral(undefined)
                setKyc(undefined)
                setTxnwith(undefined)
                setWalletLedger(undefined)
                setTxn(res.data)
            }).catch((e) => {
                console.log(e)
            })
    }
    
    const withdrawalHis = () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`txnwith_history/user/${path}`, { headers })
            .then((res) => {
                setTxn(undefined)
                setchallenge(undefined)
                setReferral(undefined)
                setKyc(undefined)
                setWalletLedger(undefined)
                setTxnwith(res.data)
            }).catch((e) => {
                console.log(e)
            })
    }

    const fetchWalletLedger = () => {
        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }
        axios
            .get(`${baseUrl}txn/wallet-ledger/user/${path}?limit=500`, { headers })
            .then((res) => {
                setchallenge(undefined)
                setTxn(undefined)
                setTxnwith(undefined)
                setReferral(undefined)
                setKyc(undefined)
                const rows = res.data?.entries
                setWalletLedger(Array.isArray(rows) ? rows : [])
            })
            .catch((e) => {
                console.log(e)
                setWalletLedger([])
            })
    }
    
    const dateFormat = (e) => {
        const date = new Date(e);
        const newDate = date.toLocaleString('default', { month: 'long', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
        return newDate;
    }

    /** Full date + time for tables (do not use .split(',') — it removes time/year). */
    const formatDateTime = (value) => {
        if (value == null || value === '') return '—';
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return '—';
        return d.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    }

    const referralHis = async () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        await axios.get(baseUrl+`referral/code/winn/${user.referral_code}`, { headers })
            .then((res) => {
                setchallenge(undefined);
                setTxn(undefined)
                setTxnwith(undefined)
                setWalletLedger(undefined)
                setKyc(undefined);
                setReferral(res.data)
                console.log(res.data)
            }).catch((e) => {
                console.log(e)
            })
    }

    const handleAdminKycAadharDigits = (e) => {
        const v = e?.target?.value ?? ''
        if (v.length <= 12 && /^\d*$/.test(v)) {
            setAdminKyc((prev) => ({ ...(prev || {}), number: v }))
        }
    };

    const submitAdminKyc = async (e) => {
        e.preventDefault();
        setAdminKycMsg('');
        if (!path) return;
        const aadharDigits = String(adminKyc.number || '').replace(/\D/g, '')
        if (aadharDigits.length !== 12) {
            setAdminKycMsg('Enter a valid 12-digit Aadhaar number.');
            return;
        }
        if (!adminKycFiles.front || !adminKycFiles.back) {
            setAdminKycMsg('Front and back images are required.');
            return;
        }
        const name = String(adminKyc.name ?? '').trim();
        const email = String(adminKyc.email ?? '').trim();
        const dob = String(adminKyc.dob ?? '').trim();
        if (!name) {
            setAdminKycMsg('Full name is required.');
            return;
        }
        if (!email) {
            setAdminKycMsg('Email is required.');
            return;
        }
        if (!/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
            setAdminKycMsg('Please select date of birth using the calendar (required).');
            return;
        }
        const access_token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${access_token}` };
        const formData = new FormData();
        formData.append('Name', name);
        formData.append('Email', email);
        formData.append('Number', aadharDigits);
        formData.append('DOB', dob);
        formData.append('front', adminKycFiles.front);
        formData.append('back', adminKycFiles.back);
        const apiRoot = String(baseUrl || '').replace(/\s+/g, '').replace(/\/+$/, '');
        const uploadUrl = apiRoot ? `${apiRoot}/aadharcard/admin/for-user/${path}` : `aadharcard/admin/for-user/${path}`;
        setAdminKycSubmitting(true);
        try {
            const res = await axios.post(uploadUrl, formData, { headers });
            if (res.data && res.data.msg && !res.data._id) {
                setAdminKycMsg(res.data.msg);
            } else {
                setAdminKycMsg('KYC submitted for this user. Status is pending for your review.');
                setAdminKycFiles({ front: null, back: null });
                getUser();
                getKyc();
            }
        } catch (err) {
            const raw = err.response?.data;
            let m = err.message || 'Request failed';
            if (typeof raw === 'string' && raw.trim()) m = raw.trim();
            else if (raw && typeof raw === 'object') m = raw.msg || raw.message || raw.error || m;
            setAdminKycMsg(m);
            if (err.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.reload();
            }
        } finally {
            setAdminKycSubmitting(false);
        }
    };

    const getKyc = () => {
        if (!path) return
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`admin/user/kyc/${path}`, { headers })
            .then((res) => {
                setTxn(undefined)
                setTxnwith(undefined)
                setWalletLedger(undefined)
                setReferral(undefined)
                setchallenge(undefined)
                setKyc(normalizeKycList(res.data))
                console.log(res.data);
            })
            .catch((e) => {
                console.log(e)
                setKyc([])
            })
    }

    function imageViewer() {
        const imgs = document.getElementsByClassName('kyc-doc-img')
        const out = document.getElementsByClassName('img-out')[0]
        if (!out) return
        for (let i = 0; i < imgs.length; i++) {
            const imgEl = imgs[i]
            if (imgEl.classList.contains('el')) continue
            imgEl.classList.add('el')
            imgEl.addEventListener('click', function lightImage(ev) {
                const container = ev.currentTarget.closest('.img-panel')
                if (!container) return
                container.classList.toggle('img-panel__selct')
            })
            imgEl.addEventListener('click', function openImage(ev) {
                const srcImg = ev.currentTarget
                const container = srcImg.closest('.img-panel')
                if (!container || !out) return
                const imgElement = document.createElement('img')
                const imgWrapper = document.createElement('div')
                const imgClose = document.createElement('div')
                container.classList.add('img-panel__selct')
                imgElement.setAttribute('class', 'image__selected')
                imgElement.src = srcImg.src || ''
                imgWrapper.setAttribute('class', 'img-wrapper')
                imgClose.setAttribute('class', 'img-close')
                imgWrapper.appendChild(imgElement)
                imgWrapper.appendChild(imgClose)
                setTimeout(function () {
                    imgWrapper.classList.add('img-wrapper__initial')
                    imgElement.classList.add('img-selected-initial')
                }, 50)
                out.appendChild(imgWrapper)
                imgClose.addEventListener('click', function () {
                    container.classList.remove('img-panel__selct')
                    if (imgWrapper.parentNode === out) out.removeChild(imgWrapper)
                })
            })
        }
    }
    
    const update = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl+`aadharcard/${Id}`,
            { verified: "verified" },
            { headers })
            .then((res) => {
                getUser();
                getKyc();
            })
    }

    const updateMismatch = async (id) => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        const uid =
            id && typeof id === "object" && id._id != null
                ? id._id
                : id;
        try {
            const res = await axios.patch(
                `${baseUrl}user/missmatch/clear/${uid}`,
                {},
                { headers }
            );
            const d = res.data;
            if (d?.data?.mismatch_fixed) {
                const extra =
                    d?.data?.loseAmount_added != null
                        ? `\nLedger adjust (loseAmount +₹${Number(d.data.loseAmount_added).toFixed(2)}). Wallet same.`
                        : "";
                alert((d.message || "Mismatch fixed.") + extra);
            } else {
                alert(
                    d?.message ||
                        "No change — wallet already matches ledger (within ₹0.01)."
                );
            }
            getUser();
        } catch (e) {
            const st = e.response?.status;
            const body = e.response?.data;
            const msg =
                (typeof body === "string" && body.trim()) ||
                body?.message ||
                body?.msg ||
                (st === 403 ? "Forbidden: Admin or Agent only." : null) ||
                e.message ||
                "Mismatch clear failed";
            alert(msg);
        }
    };

    const updateHold = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl+`user/Hold/clear/${Id}`, {}, { headers })
            .then((res) => {
                getUser();
                console.log(res);
            })
    }

    const checkfailedpayout = (txn_id, referenceId) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.post(baseUrl + `payout/response/api`, { txn_id, referenceId }, { headers })
            .then((res) => {
                const icon = res.data.status == "SUCCESS" ? "success" : "danger";
                const title = res.data.status == "SUCCESS" ? "Withdraw successfully" : "Transaction Proccessing or Failed";
            })
            .catch((e) => {
                if (e.response?.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    window.location.reload()
                }
            })
    }

    const openKycRejectModal = (Id) => {
        setKycRejectModal({
            open: true,
            id: Id,
            failReasonCode: "",
            failReasonNote: "",
            submitting: false,
        });
    };

    const closeKycRejectModal = () => {
        setKycRejectModal({
            open: false,
            id: null,
            failReasonCode: "",
            failReasonNote: "",
            submitting: false,
        });
    };

    const submitKycReject = () => {
        const { id, failReasonCode, failReasonNote } = kycRejectModal;
        if (!id) return;
        if (!failReasonCode) {
            alert("Select a reject reason for the user.");
            return;
        }
        if (failReasonCode === "other" && !failReasonNote.trim()) {
            alert("Enter a note when reason is Other.");
            return;
        }
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        setKycRejectModal((m) => ({ ...m, submitting: true }));
        axios
            .patch(
                baseUrl + `aadharcard/${id}`,
                {
                    verified: "reject",
                    failReasonCode,
                    failReasonNote: failReasonNote.trim(),
                },
                { headers }
            )
            .then(() => {
                closeKycRejectModal();
                getUser();
                getKyc();
            })
            .catch((err) => {
                alert(err.response?.data?.msg || err.message || "Reject failed");
                setKycRejectModal((m) => ({ ...m, submitting: false }));
            });
    };

    const submitWinningToDeposit = async () => {
        const amt = parseFloat(winConvAmount);
        const pct = parseFloat(winConvCommissionPct || '0');
        if (!path) return;
        if (!Number.isFinite(amt) || amt <= 0) {
            alert('Enter a valid amount greater than 0.');
            return;
        }
        if (!Number.isFinite(pct) || pct < 0 || pct > 100) {
            alert('Bonus % must be between 0 and 100.');
            return;
        }
        const winBal = Number(user?.withdrawAmount) || 0;
        if (!user || amt > winBal + 1e-9) {
            alert('Amount cannot exceed winning / withdrawable balance.');
            return;
        }
        const bonusAmt = Math.round(amt * (pct / 100) * 100) / 100;
        const msg =
            `Convert ₹${amt.toFixed(2)} from winning for ${user.Name}?\n\n` +
            `Play deposit coin +₹${amt.toFixed(2)} (wallet − winning); real totalDeposit same. ` +
            `Wallet & totalBonus +₹${bonusAmt.toFixed(2)} (${pct}% bonus). Winning −₹${amt.toFixed(2)}.`;
        if (!window.confirm(msg)) return;
        setWinConvLoading(true);
        try {
            const access_token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${access_token}` };
            const res = await axios.post(
                `${baseUrl}admin/user/winnings-to-deposit/${path}`,
                { amount: amt, bonusPercent: pct },
                { headers }
            );
            if (res.data?.success) {
                const conv = Number(res.data.depositCredited ?? res.data.amount ?? amt);
                const bonus = Number(
                    res.data.walletBonusCredited ?? res.data.bonusAmount ?? res.data.commissionAmount ?? 0
                );
                alert(
                    res.data.message ||
                    `Done. Play deposit +₹${conv.toFixed(2)}; bonus ₹${bonus.toFixed(2)}. totalDeposit unchanged.`
                );
                setWinConvAmount('');
                getUser();
            } else {
                alert(res.data?.msg || 'Failed');
            }
        } catch (e) {
            const m = e.response?.data?.msg || e.response?.data?.message || e.message || 'Request failed';
            alert(m);
            if (e.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.reload();
            }
        } finally {
            setWinConvLoading(false);
        }
    };

    const calculateExpectedBalance = (userData) => {
        if (!userData) return 0;
        const n = (v) => Math.round((Number(v) || 0) * 100) / 100;
        const raw =
            n(userData.totalDeposit) +
            n(userData.totalBonus) +
            n(userData.referral_earning) +
            n(userData.wonAmount) -
            n(userData.loseAmount) -
            n(userData.totalWithdrawl) -
            n(userData.referral_wallet) -
            n(userData.withdraw_holdbalance) -
            n(userData.hold_balance) -
            n(userData.totalPenalty);
        return Math.round(raw * 100) / 100;
    };

    const autoFixBalance = async () => {
        if (!path || Math.abs(mismatchValue) < 0.01) {
            alert("No mismatch found");
            return;
        }
        const confirmed = window.confirm(
            `Sync wallet to ledger (expected balance)?\n\n` +
            `Current: ₹${user?.Wallet_balance?.toFixed(2) || 0}\n` +
            `Expected: ₹${calculateExpectedBalance(user).toFixed(2)}\n` +
            `Difference: ₹${mismatchValue.toFixed(2)}\n` +
            `User: ${user?.Name || path}`
        );
        if (!confirmed) return;
        setLoading(true);
        try {
            await updateMismatch(path);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getUser();
        Allchallenge();
        getKyc();
        refreshOnlineStatus();
    }, [])

    useEffect(() => {
        const timer = setInterval(refreshOnlineStatus, 30000);
        return () => clearInterval(timer);
    }, [path]);

    useEffect(() => {
        if (activeTab !== 'kyc') return
        const rows = Array.isArray(kyc) ? kyc : []
        if (rows.length === 0) return
        const id = requestAnimationFrame(() => imageViewer())
        return () => cancelAnimationFrame(id)
    }, [activeTab, kyc])

    useEffect(() => {
        setAdminKyc({ name: '', email: '', dob: '', number: '' });
        setAdminKycFiles({ front: null, back: null });
        setAdminKycMsg('');
        setShowAdminKycPanel(false);
        setShowReferredUsersPanel(false);
        setActiveTab('games');
    }, [path]);

    useEffect(() => {
        if (!user) return;
        setAdminKyc((prev) => {
            const base = prev && typeof prev === 'object' ? prev : { name: '', email: '', dob: '', number: '' }
            return {
                ...base,
                name: user.holder_name != null ? String(user.holder_name) : base.name,
                email: user.Email != null ? String(user.Email) : base.email,
            }
        })
    }, [user?.holder_name, user?.Email]);

    const getReferredUsersList = () => {
        const raw = referCount
        if (!raw) return []
        if (Array.isArray(raw)) return raw
        if (Array.isArray(raw?.users)) return raw.users
        if (Array.isArray(raw?.data)) return raw.data
        if (Array.isArray(raw?.referrals)) return raw.referrals
        return []
    }

    const gameStatusBadgeClass = (s) => {
        if (!s) return 'badge-secondary';
        const x = String(s).toLowerCase();
        if (x === 'completed') return 'badge-success';
        if (x === 'running' || x === 'pending' || x === 'requested') return 'badge-primary';
        if (x === 'conflict') return 'badge-danger';
        if (x === 'cancelled' || x === 'drop') return 'badge-secondary';
        if (x === 'new') return 'badge-info';
        return 'badge-light text-dark border';
    };

    return (
        <>
            {Boolean(user) &&
                <>
                    <div className="img-out"></div>
                    <div className="lp-user-view">
                    <div className="card border-0 shadow-sm mb-4 lp-user-view-hero lp-admin-detail-card overflow-hidden">
                        <div className="card-body d-flex flex-column flex-md-row align-items-md-center gap-3 p-4">
                            <div className="lp-user-view-avatar-wrap flex-shrink-0">
                                {user.avatar ? (
                                    <img
                                        className="img rounded-circle border"
                                        src={baseUrl + `${user.avatar}`}
                                        alt=""
                                        style={{ width: '88px', height: '88px', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center border text-muted font-weight-bold" style={{ width: '88px', height: '88px', fontSize: '1.75rem' }}>
                                        {(user.Name || '?').charAt(0).toUpperCase()}
                                    </div>
                                )}
                            </div>
                            <div className="flex-grow-1 min-w-0">
                                <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                                    <h4 className="mb-0 text-dark font-weight-bold">{user?.Name ?? 'N/A'}</h4>
                                    {userIsOnline ? (
                                        <span className="badge badge-pill badge-success">Online</span>
                                    ) : (
                                        <span className="badge badge-pill badge-light text-muted border">Offline</span>
                                    )}
                                    {userOnHomePage ? (
                                        <span className="badge badge-pill badge-primary">On HomePage</span>
                                    ) : userIsOnline ? (
                                        <span className="badge badge-pill badge-light text-muted border">Other page</span>
                                    ) : null}
                                    <span className={`badge badge-pill ${user.verified === 'verified' ? 'badge-success' : 'badge-warning'}`}>{user.verified || 'unverified'}</span>
                                    <span className={`badge badge-pill ${user.user_type === 'Block' ? 'badge-danger' : 'badge-secondary'}`}>{user.user_type || 'User'}</span>
                                </div>
                                <div className="text-muted small mb-2">
                                    User ID: <code className="text-dark">{user._id}</code>
                                </div>
                                {userPhoneWhatsAppHref(user.Phone) ? (
                                <a href={userPhoneWhatsAppHref(user.Phone)} target="_blank" rel="noopener noreferrer" className="lp-admin-wa-link font-weight-bold">
                                    {displayUserPhone(user.Phone)}
                                </a>
                                ) : (
                                <span className="font-weight-bold text-muted">{displayUserPhone(user.Phone)}</span>
                                )}
                                {user.Email ? <span className="text-muted small ml-2">· {user.Email}</span> : null}
                            </div>
                            <div className="lp-user-view-stat-grid flex-shrink-0 w-100 w-md-auto">
                                <div className="lp-user-view-stat">
                                    <span className="lp-user-view-stat-label">Wallet</span>
                                    <span className="lp-user-view-stat-value">₹{Number(user.Wallet_balance || 0).toFixed(2)}</span>
                                </div>
                                <div className="lp-user-view-stat">
                                    <span className="lp-user-view-stat-label">Hold</span>
                                    <span className="lp-user-view-stat-value">₹{Number(HoldBalance || 0).toFixed(1)}</span>
                                </div>
                                <div className="lp-user-view-stat">
                                    <span className="lp-user-view-stat-label">Wins</span>
                                    <span className="lp-user-view-stat-value">₹{Number(user.wonAmount || 0).toFixed(0)}</span>
                                </div>
                                <div className="lp-user-view-stat">
                                    <span className="lp-user-view-stat-label">Joined</span>
                                    <span className="lp-user-view-stat-value text-truncate d-block" style={{ maxWidth: '7rem' }} title={user.createdAt ? new Date(user.createdAt).toLocaleDateString() : ''}>
                                        {user.createdAt ? new Date(user.createdAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 mb-4">
                            <div className="card shadow-lg h-100 lp-admin-detail-card">
                                <div className="card-header font-weight-bold">Account &amp; OTP (support)</div>
                                
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item lp-admin-kv-item">
                                        <div className="text-muted small mb-1">Active SMS OTP (not verified yet)</div>
                                        {user.otp != null && String(user.otp).trim() !== '' ? (
                                            <div>
                                                <code className="lp-admin-otp">{String(user.otp)}</code>
                                                {user.otpGeneratedAt && (
                                                    <span className="text-muted small ml-2">· sent {dateFormat(user.otpGeneratedAt)}</span>
                                                )}
                                            </div>
                                        ) : (
                                            <span className="text-muted">— none pending —</span>
                                        )}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        <div className="text-muted small mb-1">Last OTP stored after successful login</div>
                                        {user.lastLoginOtp != null && String(user.lastLoginOtp).trim() !== '' ? (
                                            <div>
                                                <code className="lp-admin-otp">{String(user.lastLoginOtp)}</code>
                                                {user.lastLoginOtpAt && (
                                                    <span className="text-muted small ml-2">· {dateFormat(user.lastLoginOtpAt)}</span>
                                                )}
                                            </div>
                                        ) : (
                                            <span className="text-muted">—</span>
                                        )}
                                    </li>
                                    {user.user_type === 'Block' && (
                                        <li className="list-group-item lp-admin-kv-item" style={{ borderLeft: '4px solid #dc2626' }}>
                                            <div className="text-muted small mb-1">Block reason</div>
                                            {user.block_reason && String(user.block_reason).trim() !== '' ? (
                                                <span>{user.block_reason}</span>
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </li>
                                    )}
                                    {(user.last_penalty_reason != null && String(user.last_penalty_reason).trim() !== '') && (
                                        <li className="list-group-item lp-admin-kv-item" style={{ borderLeft: '4px solid #b45309' }}>
                                            <div className="text-muted small mb-1">Last penalty reason</div>
                                            <span>{user.last_penalty_reason}</span>
                                            {user.last_penalty_at && (
                                                <span className="text-muted small ml-2">· {dateFormat(user.last_penalty_at)}</span>
                                            )}
                                        </li>
                                    )}
                                    
                                    <li className="list-group-item lp-admin-kv-item" style={{ borderLeft: mismatchValue !== 0 ? '4px solid #dc2626' : '4px solid #059669' }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Wallet Balance: {user.Wallet_balance.toFixed(2)}</span>
                                            <div>
                                                {mismatchValue !== 0 && (
                                                    <button 
                                                        className="btn btn-danger btn-sm"
                                                        onClick={autoFixBalance}
                                                        disabled={loading}
                                                    >
                                                        {loading ? 'Fixing...' : `Fix ₹${Math.abs(mismatchValue).toFixed(2)}`}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                    
                                    <li className="list-group-item lp-admin-kv-item">
                                        <small className="text-warning">
                                            Expected Balance: {calculateExpectedBalance(user).toFixed(2)}
                                        </small>
                                    </li>
                                    
                                    <li className="list-group-item lp-admin-kv-item" style={{
                                        color: mismatchValue > 0 ? '#059669' : mismatchValue < 0 ? '#dc2626' : '#64748b'
                                    }}>
                                        <small>
                                            Mismatch: {mismatchValue > 0 ? '+' : ''}{mismatchValue.toFixed(2)}
                                            {mismatchValue !== 0 && (
                                                <span className="ml-2 text-warning">
                                                    ({mismatchValue > 0 ? 'Extra' : 'Less'} money)
                                                </span>
                                            )}
                                        </small>
                                    </li>
                                    
                                    <li className="list-group-item lp-admin-kv-item">
                                        Withdrawal Amount Balance: {user?.withdrawAmount?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item bg-light">
                                        <div className="font-weight-bold small mb-2">Winning → play deposit (admin)</div>
                                        <p className="small text-muted mb-2">
                                            <strong>totalDeposit</strong> change nahi hota (real deposit / withdraw rule). Sirf winning −amount, play deposit coin +amount. Wallet / <strong>totalBonus</strong> me sirf commission %. App: fixed 2%.
                                        </p>
                                        <div className="form-row align-items-end">
                                            <div className="form-group col-sm-4 mb-2 mb-sm-0">
                                                <label className="small mb-0">Amount (₹)</label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    min="0"
                                                    step="0.01"
                                                    max={user?.withdrawAmount || 0}
                                                    placeholder="Max winning bal"
                                                    value={winConvAmount}
                                                    onChange={(e) => setWinConvAmount(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group col-sm-4 mb-2 mb-sm-0">
                                                <label className="small mb-0">Extra bonus % (0–100, optional)</label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    min="0"
                                                    max="100"
                                                    step="0.1"
                                                    value={winConvCommissionPct}
                                                    onChange={(e) => setWinConvCommissionPct(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group col-sm-4 mb-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm btn-block"
                                                    disabled={winConvLoading || !(Number(user?.withdrawAmount) > 0)}
                                                    onClick={submitWinningToDeposit}
                                                >
                                                    {winConvLoading ? 'Processing…' : 'Convert'}
                                                </button>
                                            </div>
                                        </div>
                                        {(() => {
                                            const a = parseFloat(winConvAmount);
                                            const p = parseFloat(winConvCommissionPct || '0') || 0;
                                            if (!Number.isFinite(a) || a <= 0 || p < 0 || p > 100) return null;
                                            const bonus = Math.round(a * (p / 100) * 100) / 100;
                                            return (
                                                <div className="small mt-2 text-muted">
                                                    Preview: play deposit <strong>+₹{a.toFixed(2)}</strong>
                                                    {' · '}
                                                    <strong className="text-success">bonus +₹{bonus.toFixed(2)}</strong> ({p}%)
                                                    {' · '}
                                                    winning <strong>−₹{a.toFixed(2)}</strong>
                                                    {' · '}
                                                    totalDeposit <strong>same</strong>
                                                </div>
                                            );
                                        })()}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Withdrawal Hold Balance: {user?.withdraw_holdbalance?.toFixed(1) || 0}
                                        <div className="col" style={{ color: '#8c8c8c' }}>Note: If hold balance is not 0, user can't make new Withdrawal requests</div>
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Referral Balance: {user?.referral_wallet?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Referral Earning: {user?.referral_earning?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Total Deposit: {user?.totalDeposit?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Total Withdrawal: {user?.totalWithdrawl?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Total Bonus: {user?.totalBonus?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Total Penalty: {user?.totalPenalty?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Hold Balance: {HoldBalance?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Won Amount: {user?.wonAmount?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Lose Amount: {user?.loseAmount?.toFixed(1) || 0}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Referral Code: {user.referral_code}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Referral By: {user.referral}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Account Created At: {dateFormat(user.createdAt).split(',')[0]}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Account Updated At: {dateFormat(user.updatedAt).split(',')[0]}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="col-lg-6 mb-4">
                            <div className="card shadow-lg h-100 lp-admin-detail-card">
                                <div className="card-header">Bank Details</div>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item lp-admin-kv-item">
                                        Account Holder Name: {user.holder_name}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        IFSC Code: {user.ifsc_code}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Account Number: {user.account_number}
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        UPI ID: {user.upi_id}
                                    </li>
                                </ul>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item lp-admin-kv-item">
                                        Mismatch: <button onClick={() => updateMismatch(user._id)} className="btn btn-success">CLEAR ({mismatchValue.toFixed(2)})</button>
                                    </li>
                                    <li className="list-group-item lp-admin-kv-item">
                                        Hold: <button onClick={() => updateHold(user._id)} className="btn btn-success">CLEAR ({HoldBalance})</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mb-4">
                            <div className="card shadow-sm lp-admin-detail-card">
                                <div className="card-header d-flex flex-wrap justify-content-between align-items-center">
                                    <span>Referred users (this user’s code)</span>
                                    <div className="d-flex flex-wrap align-items-center">
                                        <span className="text-muted small font-weight-normal mb-0 mr-2">
                                            {getReferredUsersList().length} user{getReferredUsersList().length === 1 ? '' : 's'}
                                        </span>
                                        <button
                                            type="button"
                                            className={`btn btn-sm ${showReferredUsersPanel ? 'btn-secondary' : 'btn-outline-primary'}`}
                                            onClick={() => {
                                                setShowReferredUsersPanel((o) => {
                                                    const next = !o
                                                    if (next && user?.referral_code) {
                                                        Allrefer(user.referral_code)
                                                    }
                                                    return next
                                                })
                                            }}
                                        >
                                            {showReferredUsersPanel ? 'Close list' : 'Open list'}
                                        </button>
                                    </div>
                                </div>
                                {showReferredUsersPanel && (
                                <div className="card-body p-0">
                                    {getReferredUsersList().length === 0 ? (
                                        <p className="p-3 text-muted mb-0 small">Koi referred user nahi mila. Referral code empty ho sakta hai, ya API list khali hai.</p>
                                    ) : (
                                        <>
                                            <div className="table-responsive">
                                                <table className="table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th>Phone</th>
                                                            <th>Earning for referrer</th>
                                                            <th>Profile</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {getReferredUsersList().map((r, idx) => {
                                                            const earn = earningFromReferredForReferrer(r)
                                                            return (
                                                                <tr key={r._id || idx}>
                                                                    <td>{idx + 1}</td>
                                                                    <td>{r.Name || r.name || '—'}</td>
                                                                    <td>{displayUserPhone(r.Phone || r.phone)}</td>
                                                                    <td>
                                                                        {earn != null ? `₹${Number(earn).toFixed(2)}` : <span className="text-muted">—</span>}
                                                                    </td>
                                                                    <td>
                                                                        {r._id ? (
                                                                            <Link className="btn btn-sm btn-outline-info" to={`/user/view_user/${r._id}`}>Open</Link>
                                                                        ) : '—'}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {(() => {
                                                const sum = getReferredUsersList().reduce((s, r) => {
                                                    const v = earningFromReferredForReferrer(r)
                                                    return s + (typeof v === 'number' && !Number.isNaN(v) ? v : 0)
                                                }, 0)
                                                if (sum <= 0) return null
                                                return (
                                                    <div className="border-top px-3 py-2 small text-muted">
                                                        Tracked total from above list: <strong className="text-dark">₹{sum.toFixed(2)}</strong>
                                                    </div>
                                                )
                                            })()}
                                        </>
                                    )}
                                </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row ">
                        <div className="col-12 grid-margin">
                            <div className="card lp-admin-detail-card border-0 shadow-sm">
                                <div className="card-header bg-white border-bottom py-3">
                                    <h5 className="mb-2 font-weight-bold text-dark">User activity</h5>
                                    <p className="text-muted small mb-3 mb-md-0">Games, deposits, withdrawals, full wallet ledger (all credits/debits), referrals, and KYC.</p>
                                    <div className="d-flex flex-wrap align-items-center gap-2 mt-3">
                                        <div className="btn-group flex-wrap lp-user-view-tab-group" role="group" aria-label="User activity tabs">
                                            <button type="button" className={`btn btn-sm ${activeTab === 'games' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setActiveTab('games'); Allchallenge(); }}>Game history</button>
                                            <button type="button" className={`btn btn-sm ${activeTab === 'deposit' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setActiveTab('deposit'); transactionHis(); }}>Deposits</button>
                                            <button type="button" className={`btn btn-sm ${activeTab === 'withdraw' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setActiveTab('withdraw'); withdrawalHis(); }}>Withdrawals</button>
                                            <button type="button" className={`btn btn-sm ${activeTab === 'wallet' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setActiveTab('wallet'); fetchWalletLedger(); }}>Wallet ledger</button>
                                            <button type="button" className={`btn btn-sm ${activeTab === 'referral' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setActiveTab('referral'); referralHis(); }}>Referral</button>
                                            <button type="button" className={`btn btn-sm ${activeTab === 'kyc' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => { setActiveTab('kyc'); getKyc(); }}>KYC</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {user && user.verified !== 'verified' && (
                                        <button
                                            type="button"
                                            className={`btn mb-3 mr-2 ${showAdminKycPanel ? 'btn-secondary' : 'btn-outline-primary'}`}
                                            onClick={() => setShowAdminKycPanel((v) => !v)}
                                        >
                                            {showAdminKycPanel ? 'Close user KYC upload' : 'User KYC upload'}
                                        </button>
                                    )}

                                    {user && user.verified !== 'verified' && showAdminKycPanel && (
                                        <div className="border rounded p-3 mt-2 mb-3 bg-light">
                                            <h6 className="mb-2">Aadhaar upload for this user</h6>
                                            <form onSubmit={submitAdminKyc}>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label>Full name (as on Aadhaar)</label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            value={adminKyc.name}
                                                            onChange={(e) => {
                                                                const v = e?.target?.value ?? ''
                                                                setAdminKyc((p) => ({ ...(p || {}), name: v }))
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Email</label>
                                                        <input
                                                            type="email"
                                                            className="form-control form-control-sm"
                                                            value={adminKyc.email}
                                                            onChange={(e) => {
                                                                const v = e?.target?.value ?? ''
                                                                setAdminKyc((p) => ({ ...(p || {}), email: v }))
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Date of birth</label>
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            value={adminKyc.dob}
                                                            onChange={(e) => {
                                                                const v = e?.target?.value ?? ''
                                                                setAdminKyc((p) => ({ ...(p || {}), dob: v }))
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>12-digit Aadhaar number</label>
                                                        <input
                                                            type="tel"
                                                            className="form-control form-control-sm"
                                                            inputMode="numeric"
                                                            autoComplete="off"
                                                            value={adminKyc.number}
                                                            onChange={handleAdminKycAadharDigits}
                                                            placeholder="Digits only"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Aadhaar front (JPEG/PNG/WEBP, max 10MB)</label>
                                                        <input
                                                            type="file"
                                                            accept="image/jpeg,image/png,image/webp"
                                                            className="form-control-file form-control-sm"
                                                            onChange={(e) => {
                                                                const f = e?.target?.files?.[0] ?? null
                                                                setAdminKycFiles((p) => ({ ...(p || {}), front: f }))
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Aadhaar back</label>
                                                        <input
                                                            type="file"
                                                            accept="image/jpeg,image/png,image/webp"
                                                            className="form-control-file form-control-sm"
                                                            onChange={(e) => {
                                                                const f = e?.target?.files?.[0] ?? null
                                                                setAdminKycFiles((p) => ({ ...(p || {}), back: f }))
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <button type="submit" className="btn btn-primary btn-sm" disabled={adminKycSubmitting}>
                                                    {adminKycSubmitting ? 'Uploading…' : 'Submit KYC for user'}
                                                </button>
                                            </form>
                                            {adminKycMsg ? (
                                                <div className={`small mt-2 ${adminKycMsg.includes('failed') || adminKycMsg.includes('required') || adminKycMsg.includes('Invalid') ? 'text-danger' : 'text-success'}`}>
                                                    {adminKycMsg}
                                                </div>
                                            ) : null}
                                        </div>
                                    )}

                                    {activeTab === 'games' && Boolean(challenge) && (
                                    <div className="table-responsive lp-user-view-table-wrap">
                                        <table className="table table-hover table-sm mb-0 lp-user-view-table">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Room</th>
                                                    <th>Creator</th>
                                                    <th>Accepter</th>
                                                    <th>Stake</th>
                                                    <th>Win/Lose</th>
                                                    <th>Closing bal.</th>
                                                    <th>Status</th>
                                                    <th>Type</th>
                                                    <th>Winner</th>
                                                    <th>Created</th>
                                                    <th>Updated</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {challenge.map((game, key) => (
                                                    <tr key={game._id || key}>
                                                        <td>{key + 1}</td>
                                                        <td>
                                                            {game.Room_code === 0 ? (
                                                                <span className="text-muted small">Waiting</span>
                                                            ) : (
                                                                <span className="font-weight-bold text-success">{game.Room_code}</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <span className="small">{game.Created_by?.Name ?? '—'}</span>
                                                        </td>
                                                        <td>
                                                            <span className="small">{game.Accepetd_By ? game.Accepetd_By.Name : '—'}</span>
                                                        </td>
                                                        <td>₹{game.Game_Ammount}</td>
                                                        <td className="small">
                                                            {game.Winner ? ((user._id === game.Winner._id) ? '+' + game.winnAmount : '-' + game.Game_Ammount) : ((user._id === game.Created_by?._id ? game.winnAmount : '-' + game.winnAmount))}
                                                        </td>
                                                        <td className="small">{game.Winner ? ((user._id === game.Winner._id) ? game.Winner_closingbalance : game.Loser_closingbalance) : ((user._id === game.Created_by?._id ? game.Loser_closingbalance : game.Winner_closingbalance))}</td>
                                                        <td><span className={`badge ${gameStatusBadgeClass(game.Status)}`}>{game.Status}</span></td>
                                                        <td className="small">{game.Game_type}</td>
                                                        <td className="small">{game.Winner ? game.Winner.Name : '—'}</td>
                                                        <td className="small text-nowrap">{formatDateTime(game.createdAt)}</td>
                                                        <td className="small text-nowrap">{formatDateTime(game.updatedAt)}</td>
                                                        <td className="text-nowrap">
                                                            {game._id ? (
                                                                <Link className="btn btn-sm btn-outline-primary" to={`/view/${game._id}`}>
                                                                    View game
                                                                </Link>
                                                            ) : (
                                                                <span className="text-muted small">—</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>)}
                                    {activeTab === 'games' && !challenge && (
                                        <p className="text-muted small mb-0">Loading games… or none loaded. Use <strong>Game history</strong> tab again to refresh.</p>
                                    )}
                                    
                                    {activeTab === 'deposit' && Boolean(txn) && (
                                    <div className="table-responsive lp-user-view-table-wrap border rounded lp-user-deposit-section" style={{ borderColor: '#adb5bd', borderWidth: '2px' }}>
                                        <table className='table mb-0'>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th> ID</th>
                                                    <th> Amount </th>
                                                    <th> Closing balance</th>
                                                    <th> Status </th>
                                                    <th> Payment gatway </th>
                                                    <th> Date </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {txn.map((data, key) => (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{data._id}</td>
                                                        <td>{data.amount}</td>
                                                        <td> {data.closing_balance}</td>
                                                        <td className='font-weight-bold text-success'>{data.status}</td>
                                                        <td> {(data.payment_gatway)?data.payment_gatway:''}</td>
                                                        <td>{dateFormat(data.updatedAt).split(',')[0]} </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    )}
                                    
                                    {activeTab === 'withdraw' && Boolean(txnwith) && <div className="table-responsive lp-user-view-table-wrap">
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th> ID</th>
                                                    <th> type</th>
                                                    <th> Amount </th>
                                                    <th> Closing balance</th>
                                                    <th> Status </th>
                                                    <th> Action </th>
                                                    <th> Date </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {txnwith && txnwith.map((data, key) => (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{data._id}</td>
                                                        <td>
                                                            <span className="pl-2">{data.Withdraw_type}</span>
                                                        </td>
                                                        <td>{data.amount}</td>
                                                        <td> {data.closing_balance}</td>
                                                        <td className='font-weight-bold text-success'>{data.status}</td>
                                                        <td>
                                                            {(data.status != 'SUCCESS'  &&  data.amount == user.withdraw_holdbalance) ? 
                                                                <button className="btn btn-danger" onClick={() => checkfailedpayout(data.payment_gatway, data._id, data.referenceId)} >Check {data.payment_gatway}</button> : 'Checked'
                                                            }
                                                        </td>
                                                        <td>{dateFormat(data.updatedAt).split(',')[0]}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>}

                                    {activeTab === 'wallet' && Array.isArray(walletLedger) && (
                                        <div className="table-responsive lp-user-view-table-wrap border rounded lp-user-deposit-section" style={{ borderColor: '#adb5bd', borderWidth: '2px' }}>
                                            <p className="small text-muted px-3 pt-3 mb-2 mb-md-3">
                                                Full timeline of wallet movements (payments, withdrawals, games, bonuses, penalties, conversions). Newest first.
                                                <span className="d-block mt-1"><strong>Wallet +/-</strong> = effect on main wallet when known; pending gateway rows show 0 until paid.</span>
                                            </p>
                                            <table className="table table-sm table-hover mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>When</th>
                                                        <th>Source</th>
                                                        <th>Wallet +/-</th>
                                                        <th>Amount</th>
                                                        <th>Closing bal.</th>
                                                        <th>Status</th>
                                                        <th>Detail</th>
                                                        <th>Ref</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {walletLedger.length === 0 ? (
                                                        <tr>
                                                            <td colSpan={9} className="text-muted small">No ledger entries.</td>
                                                        </tr>
                                                    ) : (
                                                        walletLedger.map((row, key) => {
                                                            const d = row.walletDelta
                                                            const deltaCell =
                                                                d == null || Number.isNaN(d) ? (
                                                                    <span className="text-muted">—</span>
                                                                ) : d >= 0 ? (
                                                                    <span className="text-success font-weight-bold">+₹{d}</span>
                                                                ) : (
                                                                    <span className="text-danger font-weight-bold">₹{d}</span>
                                                                )
                                                            const detailParts = [row.detail, row.walletNote, row.gateway]
                                                                .filter(Boolean)
                                                                .join(' · ')
                                                            return (
                                                                <tr key={row.ref && row.ref.id ? `${row.ref.kind}-${row.ref.id}` : key}>
                                                                    <td>{key + 1}</td>
                                                                    <td className="text-nowrap small">{formatDateTime(row.at)}</td>
                                                                    <td className="small">{row.source}</td>
                                                                    <td>{deltaCell}</td>
                                                                    <td className="small">{row.amount != null ? `₹${row.amount}` : '—'}</td>
                                                                    <td className="small">{row.closingBalance != null ? row.closingBalance : '—'}</td>
                                                                    <td className="small">{row.status != null ? row.status : '—'}</td>
                                                                    <td className="small" style={{ maxWidth: 280 }}>{detailParts || '—'}</td>
                                                                    <td className="small text-monospace" style={{ fontSize: 11 }}>
                                                                        {row.ref ? `${row.ref.kind?.slice(0, 3)}…${String(row.ref.id).slice(-6)}` : '—'}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {activeTab === 'wallet' && walletLedger === undefined && (
                                        <p className="text-muted small mb-0">Loading wallet ledger…</p>
                                    )}
                                    
                                    {activeTab === 'referral' && Boolean(referral) && <div className="table-responsive lp-user-view-table-wrap">
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th> ID</th>
                                                    <th> Earned by</th>
                                                    <th> Amount </th>
                                                    <th> Closing balance</th>
                                                    <th> Date </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {referral.map((data, key) => (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{data._id}</td>
                                                        <td>
                                                            {data.earned_from.Name}
                                                        </td>
                                                        <td>{data.amount}</td>
                                                        <td>
                                                            {data.closing_balance}
                                                        </td>
                                                        <td>{dateFormat(data.updatedAt).split(',')[0]} </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>}
                                    
                                    {activeTab === 'kyc' && Array.isArray(kyc) && kyc.length > 0 && <div className="table-responsive lp-user-view-table-wrap">
                                        <table className="table table-sm table-hover lp-kyc-table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th> ID</th>
                                                    <th>Method</th>
                                                    <th>Doc name</th>
                                                    <th> Aadhar no</th>
                                                    <th>DOB</th>
                                                    <th> Document-Front</th>
                                                    <th> Document-Back</th>
                                                    <th>Online KYC details</th>
                                                    <th> status </th>
                                                    <th>Date</th>
                                                    <th> Approve or Reject </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {kyc.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item._id}</td>
                                                        <td><KycMethodBadge item={item} /></td>
                                                        <td>{item.Name}</td>
                                                        <td><KycAadhaarCell item={item} /></td>
                                                        <td>{item.DOB}</td>
                                                        <td>
                                                            <KycDocumentImage item={item} baseUrl={baseUrl} side="front" index={index} />
                                                        </td>
                                                        <td>
                                                            <KycDocumentImage item={item} baseUrl={baseUrl} side="back" index={index} />
                                                        </td>
                                                        <td style={{ minWidth: "12rem" }}>
                                                            <KycOtpDetails item={item} />
                                                        </td>
                                                        <td><span className={(item.verified==="reject")?'btn btn-danger':'btn btn-success'}>{item.verified}</span> </td>
                                                        <td>{formatDateTime(item.updatedAt)}</td>
                                                        <td>
                                                            <button className="btn btn-success mr-1" disabled={(item.verified==="verified")? true:false}  onClick={() => update(item._id)}>Approve</button>
                                                            <button className="btn btn-danger" disabled={item.verified === "verified"} onClick={() => openKycRejectModal(item._id)}>Reject</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>}
                                    {activeTab === 'kyc' && kyc === undefined && (
                                        <p className="text-muted small mb-0">Loading KYC…</p>
                                    )}
                                    {activeTab === 'kyc' && Array.isArray(kyc) && kyc.length === 0 && (
                                        <p className="text-muted small mb-0">No KYC record for this user yet. Use <strong>User KYC upload</strong> (admin) for manual Aadhaar photos, or ask the user to complete <strong>Online OTP KYC</strong> from the app.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </>
            }

            {kycRejectModal.open && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Reject manual KYC</h5>
                                <button type="button" className="close" onClick={closeKycRejectModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <KycRejectReasonFields
                                    failReasonCode={kycRejectModal.failReasonCode}
                                    onFailReasonCodeChange={(v) =>
                                        setKycRejectModal((m) => ({ ...m, failReasonCode: v }))
                                    }
                                    failReasonNote={kycRejectModal.failReasonNote}
                                    onFailReasonNoteChange={(v) =>
                                        setKycRejectModal((m) => ({ ...m, failReasonNote: v }))
                                    }
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeKycRejectModal}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    disabled={kycRejectModal.submitting}
                                    onClick={submitKycReject}
                                >
                                    {kycRejectModal.submitting ? "Rejecting…" : "Reject KYC"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}